module.exports = __webpack_public_path__ + "img/9852b56a702530c34fd12f39d0648548.7acc4953.png";